"use client";

import { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { usePathname } from "next/navigation";

interface HomeIntroContextType {
  hasClickedIntro: boolean;
  setHasClickedIntro: (value: boolean) => void;
  showHomeNav: boolean;
  setShowHomeNav: (value: boolean) => void;
  menuImages?: {
    aboutImage?: string;
    collectionImage?: string;
  };
  setMenuImages: (images: { aboutImage?: string; collectionImage?: string }) => void;
}

const HomeIntroContext = createContext<HomeIntroContextType | undefined>(
  undefined
);

export function HomeIntroProvider({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const [hasClickedIntro, setHasClickedIntro] = useState(false);
  const [showHomeNav, setShowHomeNav] = useState(false);
  const [menuImages, setMenuImages] = useState<{ aboutImage?: string; collectionImage?: string }>({});

  // If loading on or navigating to a non-home page, mark intro as seen
  useEffect(() => {
    if (pathname !== "/") {
      setHasClickedIntro(true);
    }
  }, [pathname]);

  return (
    <HomeIntroContext.Provider value={{ hasClickedIntro, setHasClickedIntro, showHomeNav, setShowHomeNav, menuImages, setMenuImages }}>
      {children}
    </HomeIntroContext.Provider>
  );
}

export function useHomeIntro() {
  const context = useContext(HomeIntroContext);
  if (context === undefined) {
    throw new Error("useHomeIntro must be used within a HomeIntroProvider");
  }
  return context;
}
